import { render, staticRenderFns } from "./EmailSelection.vue?vue&type=template&id=6c271c30&scoped=true&"
import script from "./EmailSelection.vue?vue&type=script&lang=js&"
export * from "./EmailSelection.vue?vue&type=script&lang=js&"
import style0 from "./EmailSelection.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EmailSelection.vue?vue&type=style&index=1&id=6c271c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c271c30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c271c30')) {
      api.createRecord('6c271c30', component.options)
    } else {
      api.reload('6c271c30', component.options)
    }
    module.hot.accept("./EmailSelection.vue?vue&type=template&id=6c271c30&scoped=true&", function () {
      api.rerender('6c271c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/EmailSelection.vue"
export default component.exports